/* eslint-disable */
import React, { useEffect, useState, useReducer } from "react";
import "./deliveryAddsPopup.scss";
import { useHistory } from "react-router-dom";

// material ui

import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

// localizations
import { withTranslation, useTranslation, Trans } from "react-i18next";
// redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import {
  Avatar,
  InputLabel,
  TextareaAutosize,
  useMediaQuery,
} from "@material-ui/core";
import { get_lang } from "../../../../global-functions/apiGlobal";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import SelectedFields from "../../components/selectFields/selectedfields";
import StandardBtn from "../StandardButton/StandardBtn";
import { Dining, Fastfood } from "@mui/icons-material";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../redux-store/store";

function NewDeliveryPopup({ table }) {
  const history = useHistory();
  const appDispatch = useDispatch();
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const appState = useSelector((state) => state);
  const matches = useMediaQuery("(min-width:1200px)");
  const {setDeliveryAddsInfo, setPickupOrDelivery} = bindActionCreators(actionCreators, appDispatch);
  const [options, setOptions] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  const [disableBtn, setDisableBtn] = useState(false)
  const [areasObj, setAreasObj] = useState([])
  const [areaBranchId, setAreaBranchId] = useState(null)
  const [pickupBranch, setPickupBranch] = useState(null)
  const pickupDeliveryTypes = process.env.REACT_APP_PICKUP_DELIVERY?.split(',') || ['pickup'];
  console.log(pickupDeliveryTypes, "pickupDeliveryTypes")
  const showDeliveryPickupOptions = pickupDeliveryTypes.length > 1;
  const showPickupOption =  pickupDeliveryTypes?.length == 1 && pickupDeliveryTypes.includes('pickup');
  const [currentOption, setCurrentOption] = useState('pickup')
  

  // This is used only for the example
  const [location, setLocation] = useState(
    appState.deliveryAddsInfo != null
      ? appState.deliveryAddsInfo
      : {
          lat: 24.872130930013252,
          lng: 66.9828699111145,
        }
  );

  const handleChangeText = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setLocation({
      ...location,
      [name]: value,
    });

    if (name === "branch_id") {
      setAreaBranchId(value)
      setDisableBtn(false)
    }
    if (name === "city_id") {
      // Find the corresponding label based on the selected value
      const selectedOption = options.find((option) => option.value === value);
      const label = selectedOption ? selectedOption.label : "";
      setDeliveryAddsInfo({
        ...appState.deliveryAddsInfo,
        city_id: value,
        city_name: label,
      });
      setDisableBtn(true)
    } else if (name === "area_id") {
      const selectedOption = areaOptions.find(
        (option) => option.value === value
      );
      const label = selectedOption ? selectedOption.label : "";
      setAreaBranchId(selectedOption?.branchId)

      setDeliveryAddsInfo({
        ...appState.deliveryAddsInfo,
        area_id: value,
        area_name: label,
        qrBranch: selectedOption?.branchId
      });

      setDisableBtn(false)
    }
  };


  const arLanguageHandle = (e) => {
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
  };
  const enLanguageHandle = (e) => {
    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };
  const getAreas = (areasArr) =>{
    
    if (appState.deliveryAddsInfo?.area_id != "") {
      let areas = areasObj.length > 0 ? areasObj : areasArr
      let area_Options = [];
      let findAreas = areas.filter(
        (ele) => ele.cityId == appState.deliveryAddsInfo?.city_id
      )

      
      // if (findAreas?.length > 0) {
      //   findAreas.forEach((ele) => {
      //     area_Options.push({ value: ele.value , label: ele.label });
      //   });
      // }
      
      setAreaOptions(findAreas);
    }
  }
  useEffect(() => {
    if (appState.countryCityArea?.length > 0) {
      let optionData = [];
      let areasArr = [];
  
      const citySet = new Set(); // To track unique city IDs
      const areaSet = new Set(); // To track unique area IDs // get distinguished cities
  
      // Traverse each branch in the data
      appState.countryCityArea.forEach((obj) => {
        // Traverse each city in the obj's areas
        obj.areas.forEach((cityData) => {
          const city = cityData.city; // Extract the city object
          
          // Check if the city ID is already in the set
          if (!citySet.has(city.id)) {
            citySet.add(city.id); // Add city ID to the set
            optionData.push({ value: city.id, label: city.name }); // Push city info
          }
          
          // Traverse each area within the city
          cityData.areas.forEach((area) => {
            // Check if the area ID is already in the set
            if (!areaSet.has(area.id)) {
              areaSet.add(area.id); // Add area ID to the set
              areasArr.push({
                branchId: obj?.branch?.id,
                cityId: city.id,
                value: area.id,
                label: area.name,
              });
            }
          });
        });
      });
  
      
      setOptions(optionData);
      setAreasObj(areasArr);
      let findArea = appState.pickupOrDelivery == "delivery" ? areasArr.find(ele => ele.value == appState.deliveryAddsInfo?.area_id)?.branchId : appState.qrBranch
      setAreaBranchId(findArea)
      // getAreas(areasArr)
      
    }
    if(appState.pickupOrDelivery == "pickup"  && areaBranchId != null){
      setAreaBranchId(areaBranchId)
      setDisableBtn(false)
    }else if(appState.pickupOrDelivery == "delivery"  && appState.deliveryAddsInfo?.city_id != "" && appState.deliveryAddsInfo?.area_id != ""){
      setDisableBtn(false)
    }
    
  }, []);
  
  useEffect(() => {
    if (appState.deliveryAddsInfo?.city_id != "") {
     getAreas([]);
    }
  }, [appState.deliveryAddsInfo?.city_id,areasObj]);

  const handleConfirm = () => {
    const { address, lat, lng } = location;
    appDispatch({ type: "SET_BRANCH", qrBranch: areaBranchId });
    appDispatch({ type: "SET_PICKUP_OR_DELIVERY", pickupOrDelivery: currentOption });
    appDispatch({ type: "setDeliveryAddsPopup", deliveryAddsPopup: false });
    appDispatch({ type: "updateCart", cart: [] }); 
  };

  console.log(appState.pickupOrDelivery, "appState.pickupOrDelivery")

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 2,
        }}
        open={appState.deliveryAddsPopup}
        className="payTableBackdrop"
      />

      <div
        id="mySidenav"
        className={`deliveryAddsPopup pb-3  ${
          appState.langValue == "ar" ? "ArabicDeliveryAddsPopup" : " "
        } ${appState.deliveryAddsPopup ? "deliveryAddsPopupActive" : ""}`}
      >
        <div id="storeTitlePayTable">
          <div className="container-fluid py-3">
            <div className="row">
              <div className="col-12 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <Link to="/">
                    <div className="DeliverySvg">
                      { currentOption === "delivery" ? <DeliveryDiningIcon /> : <Fastfood /> }
                    </div>
                  </Link>

                  <div className="mt-2 px-3">
                    <h1
                      className={`d-flex familyPoppins300 ${
                        appState.langValue === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      { currentOption === "delivery" ? t("Delivery") : t("Pickup") }
                    </h1>

                    { currentOption == "delivery" &&
                      <h1
                        className={`d-flex align-items-center  tableNo ${
                          appState.langValue === "ar"
                            ? "text-right familyGraphikArabic"
                            : "text-left familyPoppins300"
                        }`}
                      >
                        <span>
                          {appState.deliveryAddsInfo?.city_name
                            ? get_lang(
                                appState.deliveryAddsInfo?.city_name,
                                appState.langValue
                              )
                            : `City`}
                        </span>
                        <span
                          className={` px-1 ${
                            appState.langValue === "ar"
                              ? "text-right familyGraphikArabic"
                              : "text-left familyPoppins300"
                          }`}
                        >
                          {" "}
                          {appState.deliveryAddsInfo?.area_name
                            ? ` >  ${get_lang(
                                appState.deliveryAddsInfo?.area_name,
                                appState.langValue
                              )}`
                            : ` >  Area`}{" "}
                        </span>
                      </h1>
                    }
                  </div>
                </div>
                {appState.langValue == "ar" ? (
                  <Button
                    className={`infoBtn ${
                      appState.langValue === "ar"
                        ? "classForAr familyGraphikArabic600"
                        : "familyManrope600"
                    }`}
                    variant="outlined"
                    onClick={(e) => enLanguageHandle(e)}
                  >
                    EN
                  </Button>
                ) : (
                  <Button
                    className={`infoBtn pb-3 ${
                      appState.langValue === "ar"
                        ? "classForAr familyGraphikArabic600"
                        : "classForAr familyGraphikArabic600"
                    }`}
                    onClick={(e) => arLanguageHandle(e)}
                    variant="outlined"
                  >
                    عربي
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>

        {showDeliveryPickupOptions && <div className="delivery-pickup-options mx-2">
         <Button 
            variant={currentOption === "delivery" ? "contained" : "outlined"}
            className={`delivery-pickup-btn ${currentOption === "delivery" ? "selected" : ""}`}
            onClick={
              // () => appDispatch({ type: "SET_PICKUP_OR_DELIVERY", pickupOrDelivery: "delivery" })/
              () => setCurrentOption("delivery")
            }
          >
            {t("Delivery")}
          </Button>
         <Button 
              variant={currentOption === "pickup" ? "contained" : "outlined"}
            className={`delivery-pickup-btn ${currentOption === "pickup" ? "selected" : ""}`}
              onClick={() => setCurrentOption("pickup")}
            // () => appDispatch({ type: "SET_PICKUP_OR_DELIVERY", pickupOrDelivery: "pickup" })}
          >
            {t("Pickup")}
          </Button>
        </div>}
        <div className="row m-0 p-0 selectLocations">
          <div className="col-12 ">
            <div className="px-2 mt-2  ">
              {currentOption == "delivery" ? 
              <>
              
            <SelectedFields
                handleChange={handleChangeText}
                name="city_id"
                value={appState.deliveryAddsInfo?.city_id}
                label="City"
                options={options}
              />

              {areaOptions.length > 0 && (
                <div
                  className="mt-3"
                  style={{
                    direction: appState.langValue == "ar" ? "rtl" : "ltr",
                  }}
                >
                  <SelectedFields
                    handleChange={handleChangeText}
                    name="area_id"
                    value={appState.deliveryAddsInfo?.area_id}
                    label="Area"
                    options={areaOptions}
                  />
                </div>
              )}
              </>
              :
              <>
              {appState.branchesList.length > 0 ? (
                <SelectedFields
                  handleChange={handleChangeText}
                  name="branch_id"
                  value={areaBranchId}
                  label="Branch"
                  options={appState.branchesList}
                />
              ) :
              <h4 className="text-center text-muted">Pickup branches not found</h4>
              }
              </>
              }

            
              {/* <FormControl sx={{ m: 1, minWidth: 120 }}> */}
              {/* <p>{label}</p> */}
              {/* <Select
            value={location.area_name}
            onChange={handleChangeText}
            // name={name}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            {options.map((item, ind) => (
              <MenuItem  key={ind}  value={item.value}>{get_lang(item.label, appState.langValue)}</MenuItem>
            ))}
          </Select> */}
              {/* <FormHelperText>Without label</FormHelperText> */}
              {/* </FormControl> */}
            </div>
          </div>
        </div>


      

        <div className="container-fluid content px-4 mt-2 confirmBtnClass ">
          <div className="row mt-3 ">
            {/* {appState.tableInvoice != null && } */}
            <div className="col-12">
              {location && (
                // <Button
                //   className={` py-3 px-4   ${ appState.langValue === "ar" ? " familyGraphikArabic600" : "" }`}
                //   onClick={handleConfirm}
                // >
                //   {t("Confirm")}
                // </Button>
                <StandardBtn 
                  label={t("Confirm")}
                  type="text-btn"
                  requiedClass={`viewMenuBtn ${disableBtn ? "disable-confirm-btn" : ""} `}
                  handleCheckout={handleConfirm}
                  disabled={disableBtn}
                />
              )}
            </div>
          </div>
        </div>
        
      </div>
    </>
  );
}

export default withTranslation()(NewDeliveryPopup);
